import { createRoute } from "@tanstack/react-router";
import { FPDevelopmentMonthlyTable } from "@/components/teams/fp-development-monthly-table";
import { TeamRosterPage } from "@/components/teams/team-roster-page";
import { Route as authenticatedRoute } from "../_authenticated";

const members = [
  {
    name: "Austin Willard",
    title: "CEO",
    ownerId: "ff0b20a1-48c1-4d2d-a654-86768917de1a",
    image: "/assets/headshots/austin-willard.png",
  },
  {
    name: "Matt Murray",
    title: "HR Director",
    ownerId: "d83b6ad4-4473-46ff-ae89-db03cf509b76",
    image: "/assets/headshots/matt-murray.png",
  },
  {
    name: "Nicholas Spalding",
    title: "COO",
    ownerId: "cd17e640-8760-48b0-aec6-1fa31c973dec",
    image: "/assets/headshots/nicholas-spalding.png",
  },
  {
    name: "Alex Sohn",
    title: "Marketing Director",
    ownerId: "43404667-980f-4ec1-8900-0abfbfafd629",
    image: "/assets/headshots/alex-sohn.png",
  },
  {
    name: "Jarrod Polson",
    title: "FP Director",
    ownerId: "216df4eb-25b9-46a4-ab19-fa7b13bef0de",
    image: "/assets/headshots/jarrod-polson.png",
  },
];

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/teams/fp/development",
  component: () => (
    <TeamRosterPage team="FP Team – Development" members={members}>
      <FPDevelopmentMonthlyTable />
    </TeamRosterPage>
  ),
});
